var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "0", "background-color": "#2D2D2D" } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "container-image" }, [
          _c("img", {
            staticStyle: {
              "object-fit": "cover",
              width: "100%",
              height: "132px"
            },
            attrs: { src: require("../../assets/account-img.png") }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "centered-text" }, [_vm._v("Contact Us")])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ab6cafc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab6cafc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contactUsImage.vue
// module id = null
// module chunks = 